export default __webpack_public_path__ + "static/media/img--balcony.3b47767c.jpg";